import { createContext, useContext } from 'react';

const SecondaryNavContext = createContext(void 0);
const useSecondaryNavContext = () => {
  const context = useContext(SecondaryNavContext);
  if (context === void 0) {
    throw new Error("useSecondaryNavContext must be used within a SecondaryNavContext (which is available by using SecondaryNav)");
  }
  return context;
};

export { SecondaryNavContext, useSecondaryNavContext };
//# sourceMappingURL=SecondaryNavContext.es.js.map
